import { useEffect, useState } from 'react';

export function useLoading(predictedLoadTime, getLabel) {
	const [, setCountdown] = useState(predictedLoadTime);
	const [message, setMessage] = useState();
	const [transitionKey, setTransitionKey] = useState('initial');

	const formatTime = (seconds) => {
		const m = Math.floor(seconds / 60)
			.toString()
			.padStart(2, '0');
		const s = (seconds % 60).toString().padStart(2, '0');
		return `${m}:${s}`;
	};

	useEffect(() => {
		let countdownInterval = setInterval(() => {
			setCountdown((countdown) => {
				if (countdown > 1) {
					setMessage(`${getLabel('loading_countdown_running')} ${formatTime(countdown - 1)}s`);
				} else {
					setTransitionKey('finished');
					setMessage(getLabel('loading_countdown_finished'));
					clearInterval(countdownInterval);
				}
				return countdown - 1;
			});
		}, 1000);

		setMessage(`${getLabel('loading_countdown_running')} ${formatTime(predictedLoadTime)}s`);

		return () => clearInterval(countdownInterval);
	}, []);

	return { message, transitionKey };
}
